import type { CancelablePromise } from './core/CancelablePromise';
import { OpenAPI } from './core/OpenAPI';
import { request as __request } from './core/request';

import type { CreateUserContextRequest,CreateUserRequest,CreateUserResponse,PersistentUserContext,PersistentUserProfile,ProjectsPaginatedResponse,ThreadsPaginatedResponse,UpdateUserContextRequest,AcceptedFileTypes,Body_files_upload_file,PersistentFile,CreateProjectRequest,PersistentProject,PersistentThread,UpdateProjectRequest,CreateThreadRequest,PersistentMessage,UpdateThreadRequest,CreateBrainRequest,PersistentBrain,UpdateBrainRequest,CreateMessageRequest,UpdateMessageRequest,Body_agents_extract_file_content,MessageRequest,CreateOrganizationRequest,Organization,OrgMembership,OrgMembersResponse,Role,UpdateOrganizationRequest,CreateClickHouseDataSourceRequest,CreateDashboardRequest,CreateMetricRequest,DashboardModel,DatasourceChatRequest,DataSourceModel,ExecuteQueryRequest,ExecuteQueryResponse,MetricModel,UpdateClickHouseDataSourceRequest,UpdateDashboardRequest,UpdateMetricRequest } from './models';

export type UsersData = {
        UsersCreateNewUser: {
                    requestBody: CreateUserRequest
                    
                };
UsersGetUserThreads: {
                    /**
 * The maximum number of threads to return. No limit by default
 */
limit?: number
/**
 * The ID of the organization to filter threads by
 */
orgId?: string
/**
 * The ID of the project to filter threads by
 */
projectId?: string
/**
 * The ID of the user whose threads to fetch
 */
userId: string
                    
                };
UsersGetUserProjects: {
                    /**
 * The maximum number of projects to return. No limit by default
 */
limit?: number
/**
 * The ID of the user whose projects to fetch
 */
userId: string
                    
                };
UsersGetUserContexts: {
                    userId: string
                    
                };
UsersCreateUserContext: {
                    requestBody: CreateUserContextRequest
                    
                };
UsersUpdateUserContext: {
                    contextId: string
requestBody: UpdateUserContextRequest
                    
                };
UsersDeleteUserContext: {
                    contextId: string
                    
                };
UsersGetUserProfileByEmail: {
                    /**
 * The email of the user to retrieve
 */
email: string
                    
                };
    }

export type FilesData = {
        FilesUploadFile: {
                    formData: Body_files_upload_file
/**
 * The ID of the project to upload file to.
 */
projectId: string
                    
                };
FilesScrapeWebPage: {
                    /**
 * The ID of the project to scrape URL for.
 */
projectId: string
/**
 * URL to scrape
 */
url: string
                    
                };
FilesGetFile: {
                    /**
 * File ID
 */
fileId: string
                    
                };
FilesDeleteFile: {
                    /**
 * The Id of the file to delete
 */
fileId: string
                    
                };
FilesIndexFile: {
                    /**
 * The ID of the file to index
 */
fileId: string
                    
                };
    }

export type ProjectsData = {
        ProjectsGetProject: {
                    projectId: string
                    
                };
ProjectsUpdateProject: {
                    projectId: string
requestBody: UpdateProjectRequest
                    
                };
ProjectsDeleteProject: {
                    projectId: string
                    
                };
ProjectsCreateProject: {
                    requestBody: CreateProjectRequest
                    
                };
ProjectsGetProjectThreads: {
                    projectId: string
                    
                };
ProjectsGetProjectFiles: {
                    projectId: string
                    
                };
ProjectsIndexProjectFiles: {
                    projectId: string
                    
                };
    }

export type ThreadsData = {
        ThreadsGetThread: {
                    threadId: string
                    
                };
ThreadsUpdateThread: {
                    requestBody: UpdateThreadRequest
threadId: string
                    
                };
ThreadsDeleteThread: {
                    threadId: string
                    
                };
ThreadsCreateThread: {
                    requestBody: CreateThreadRequest
                    
                };
ThreadsGetThreadMessages: {
                    threadId: string
                    
                };
    }

export type BrainsData = {
        BrainsCreateBrain: {
                    requestBody: CreateBrainRequest
                    
                };
BrainsUpdateBrain: {
                    /**
 * ID of brain to update
 */
brainId: string
requestBody: UpdateBrainRequest
                    
                };
BrainsDeleteBrain: {
                    /**
 * ID of brain to delete
 */
brainId: string
                    
                };
BrainsGetBrainsForUserId: {
                    /**
 * ID of user to get brains for
 */
userId: string
                    
                };
    }

export type MessagesData = {
        MessagesCreateMessage: {
                    requestBody: CreateMessageRequest
                    
                };
MessagesUpdateMessage: {
                    messageId: string
requestBody: UpdateMessageRequest
                    
                };
MessagesDeleteMessage: {
                    messageId: string
                    
                };
MessagesGetMessage: {
                    messageId: string
                    
                };
    }

export type AgentsData = {
        AgentsGetWayakResponse: {
                    requestBody: MessageRequest
                    
                };
AgentsGetSpecificAgentResponse: {
                    agentId: string
requestBody: MessageRequest
                    
                };
AgentsExtractFileContent: {
                    formData: Body_agents_extract_file_content
                    
                };
    }

export type OrganizationsData = {
        OrganizationsCreateOrganization: {
                    requestBody: CreateOrganizationRequest
                    
                };
OrganizationsGetUserOrganizations: {
                    userId: string
                    
                };
OrganizationsGetOrganization: {
                    orgId: string
                    
                };
OrganizationsUpdateOrganization: {
                    orgId: string
requestBody: UpdateOrganizationRequest
                    
                };
OrganizationsAddOrganizationMember: {
                    currentUserId: string
orgId: string
role: Role
userId: string
                    
                };
OrganizationsGetOrganizationMembers: {
                    orgId: string
                    
                };
OrganizationsRemoveOrganizationMember: {
                    currentUserId: string
orgId: string
userId: string
                    
                };
OrganizationsGetOrganizationProjects: {
                    orgId: string
                    
                };
OrganizationsGetOrganizationThreads: {
                    orgId: string
                    
                };
OrganizationsGetOrganizationBrains: {
                    orgId: string
                    
                };
    }

export type OntologyData = {
        OntologyCreateDashboard: {
                    requestBody: CreateDashboardRequest
                    
                };
OntologyGetDashboards: {
                    /**
 * Organization ID
 */
orgId: string
                    
                };
OntologyGetDashboard: {
                    /**
 * Dashboard ID
 */
dashboardId: string
                    
                };
OntologyUpdateDashboard: {
                    /**
 * Dashboard ID
 */
dashboardId: string
requestBody: UpdateDashboardRequest
                    
                };
OntologyDeleteDashboard: {
                    /**
 * Dashboard ID
 */
dashboardId: string
                    
                };
OntologyExecuteQuery: {
                    requestBody: ExecuteQueryRequest
                    
                };
OntologyChatWithDatasourceAgent: {
                    requestBody: DatasourceChatRequest
                    
                };
OntologyCreateClickhouseDatasource: {
                    requestBody: CreateClickHouseDataSourceRequest
                    
                };
OntologyGetDatasources: {
                    /**
 * Organization ID
 */
orgId: string
                    
                };
OntologyGetDatasource: {
                    /**
 * Datasource ID
 */
datasourceId: string
                    
                };
OntologyUpdateClickhouseDatasource: {
                    /**
 * Datasource ID
 */
datasourceId: string
requestBody: UpdateClickHouseDataSourceRequest
                    
                };
OntologyDeleteClickhouseDatasource: {
                    /**
 * Datasource ID
 */
datasourceId: string
                    
                };
OntologyCreateMetric: {
                    requestBody: CreateMetricRequest
                    
                };
OntologyGetMetrics: {
                    /**
 * Organization ID
 */
orgId: string
                    
                };
OntologyGetMetric: {
                    /**
 * Metric ID
 */
metricId: string
                    
                };
OntologyUpdateMetric: {
                    /**
 * Metric ID
 */
metricId: string
requestBody: UpdateMetricRequest
                    
                };
OntologyDeleteMetric: {
                    /**
 * Metric ID
 */
metricId: string
                    
                };
    }

export class UsersService {

	/**
	 * Create new user
	 * @returns CreateUserResponse Successful Response
	 * @throws ApiError
	 */
	public static usersCreateNewUser(data: UsersData['UsersCreateNewUser']): CancelablePromise<CreateUserResponse> {
		const {
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/users',
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Get all threads not assigned to a project for a user
	 * @returns ThreadsPaginatedResponse Successful Response
	 * @throws ApiError
	 */
	public static usersGetUserThreads(data: UsersData['UsersGetUserThreads']): CancelablePromise<ThreadsPaginatedResponse> {
		const {
userId,
limit,
projectId,
orgId,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/users/{user_id}/threads',
			path: {
				user_id: userId
			},
			query: {
				limit, project_id: projectId, org_id: orgId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Get all projects for a user, optional pagination parameter
	 * @returns ProjectsPaginatedResponse Successful Response
	 * @throws ApiError
	 */
	public static usersGetUserProjects(data: UsersData['UsersGetUserProjects']): CancelablePromise<ProjectsPaginatedResponse> {
		const {
userId,
limit,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/users/{user_id}/projects',
			path: {
				user_id: userId
			},
			query: {
				limit
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Get all user contexts for a user
	 * @returns PersistentUserContext Successful Response
	 * @throws ApiError
	 */
	public static usersGetUserContexts(data: UsersData['UsersGetUserContexts']): CancelablePromise<Array<PersistentUserContext>> {
		const {
userId,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/users/{user_id}/contexts',
			path: {
				user_id: userId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Create new user context
	 * @returns PersistentUserContext Successful Response
	 * @throws ApiError
	 */
	public static usersCreateUserContext(data: UsersData['UsersCreateUserContext']): CancelablePromise<PersistentUserContext> {
		const {
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/users/context',
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Update user context with given ID
	 * @returns PersistentUserContext Successful Response
	 * @throws ApiError
	 */
	public static usersUpdateUserContext(data: UsersData['UsersUpdateUserContext']): CancelablePromise<PersistentUserContext> {
		const {
contextId,
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'PUT',
			url: '/api/users/context/{context_id}',
			path: {
				context_id: contextId
			},
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Delete user context with given ID
	 * @returns void Successful Response
	 * @throws ApiError
	 */
	public static usersDeleteUserContext(data: UsersData['UsersDeleteUserContext']): CancelablePromise<void> {
		const {
contextId,
} = data;
		return __request(OpenAPI, {
			method: 'DELETE',
			url: '/api/users/context/{context_id}',
			path: {
				context_id: contextId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Get User Profile By Email
	 * @returns PersistentUserProfile Successful Response
	 * @throws ApiError
	 */
	public static usersGetUserProfileByEmail(data: UsersData['UsersGetUserProfileByEmail']): CancelablePromise<PersistentUserProfile> {
		const {
email,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/users/profile/find',
			query: {
				email
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

}

export class FilesService {

	/**
	 * Upload a file to a project with a given ID.
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static filesUploadFile(data: FilesData['FilesUploadFile']): CancelablePromise<unknown> {
		const {
projectId,
formData,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/files/{project_id}/upload',
			path: {
				project_id: projectId
			},
			formData: formData,
			mediaType: 'multipart/form-data',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Scrape web page URL and save contents as file
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static filesScrapeWebPage(data: FilesData['FilesScrapeWebPage']): CancelablePromise<unknown> {
		const {
projectId,
url,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/files/{project_id}/web',
			path: {
				project_id: projectId
			},
			query: {
				url
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Get Accepted File Types
	 * @returns AcceptedFileTypes Successful Response
	 * @throws ApiError
	 */
	public static filesGetAcceptedFileTypes(): CancelablePromise<Array<AcceptedFileTypes>> {
				return __request(OpenAPI, {
			method: 'GET',
			url: '/api/files/file_types',
		});
	}

	/**
	 * Get file with a given ID.
	 * @returns PersistentFile Successful Response
	 * @throws ApiError
	 */
	public static filesGetFile(data: FilesData['FilesGetFile']): CancelablePromise<PersistentFile> {
		const {
fileId,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/files/{file_id}',
			path: {
				file_id: fileId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Delete a file with the given ID.
	 * @returns void Successful Response
	 * @throws ApiError
	 */
	public static filesDeleteFile(data: FilesData['FilesDeleteFile']): CancelablePromise<void> {
		const {
fileId,
} = data;
		return __request(OpenAPI, {
			method: 'DELETE',
			url: '/api/files/{file_id}',
			path: {
				file_id: fileId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Create embeddings for a file with ID. Removes any prior existing embeddings.
	 * @returns PersistentFile Successful Response
	 * @throws ApiError
	 */
	public static filesIndexFile(data: FilesData['FilesIndexFile']): CancelablePromise<PersistentFile> {
		const {
fileId,
} = data;
		return __request(OpenAPI, {
			method: 'PUT',
			url: '/api/files/{file_id}/index',
			path: {
				file_id: fileId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

}

export class ProjectsService {

	/**
	 * Get a project by it's ID
	 * @returns PersistentProject Successful Response
	 * @throws ApiError
	 */
	public static projectsGetProject(data: ProjectsData['ProjectsGetProject']): CancelablePromise<PersistentProject> {
		const {
projectId,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/projects/{project_id}',
			path: {
				project_id: projectId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Update project with given ID
	 * @returns PersistentProject Successful Response
	 * @throws ApiError
	 */
	public static projectsUpdateProject(data: ProjectsData['ProjectsUpdateProject']): CancelablePromise<PersistentProject> {
		const {
projectId,
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'PUT',
			url: '/api/projects/{project_id}',
			path: {
				project_id: projectId
			},
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Delete project with given ID
	 * @returns void Successful Response
	 * @throws ApiError
	 */
	public static projectsDeleteProject(data: ProjectsData['ProjectsDeleteProject']): CancelablePromise<void> {
		const {
projectId,
} = data;
		return __request(OpenAPI, {
			method: 'DELETE',
			url: '/api/projects/{project_id}',
			path: {
				project_id: projectId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Create new project
	 * @returns PersistentProject Successful Response
	 * @throws ApiError
	 */
	public static projectsCreateProject(data: ProjectsData['ProjectsCreateProject']): CancelablePromise<PersistentProject> {
		const {
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/projects',
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Get all threads of a project
	 * @returns PersistentThread Successful Response
	 * @throws ApiError
	 */
	public static projectsGetProjectThreads(data: ProjectsData['ProjectsGetProjectThreads']): CancelablePromise<Array<PersistentThread>> {
		const {
projectId,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/projects/{project_id}/threads',
			path: {
				project_id: projectId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Get all files of a project
	 * @returns PersistentFile Successful Response
	 * @throws ApiError
	 */
	public static projectsGetProjectFiles(data: ProjectsData['ProjectsGetProjectFiles']): CancelablePromise<Array<PersistentFile>> {
		const {
projectId,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/projects/{project_id}/files',
			path: {
				project_id: projectId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Index all files of a project
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static projectsIndexProjectFiles(data: ProjectsData['ProjectsIndexProjectFiles']): CancelablePromise<unknown> {
		const {
projectId,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/projects/{project_id}/files/index',
			path: {
				project_id: projectId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

}

export class ThreadsService {

	/**
	 * Get thread details
	 * @returns PersistentThread Successful Response
	 * @throws ApiError
	 */
	public static threadsGetThread(data: ThreadsData['ThreadsGetThread']): CancelablePromise<PersistentThread> {
		const {
threadId,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/threads/{thread_id}',
			path: {
				thread_id: threadId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Update thread with given ID
	 * @returns PersistentThread Successful Response
	 * @throws ApiError
	 */
	public static threadsUpdateThread(data: ThreadsData['ThreadsUpdateThread']): CancelablePromise<PersistentThread> {
		const {
threadId,
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'PUT',
			url: '/api/threads/{thread_id}',
			path: {
				thread_id: threadId
			},
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Delete thread with given ID
	 * @returns void Successful Response
	 * @throws ApiError
	 */
	public static threadsDeleteThread(data: ThreadsData['ThreadsDeleteThread']): CancelablePromise<void> {
		const {
threadId,
} = data;
		return __request(OpenAPI, {
			method: 'DELETE',
			url: '/api/threads/{thread_id}',
			path: {
				thread_id: threadId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Create new thread
	 * @returns PersistentThread Successful Response
	 * @throws ApiError
	 */
	public static threadsCreateThread(data: ThreadsData['ThreadsCreateThread']): CancelablePromise<PersistentThread> {
		const {
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/threads',
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Get all messages for a given thread
	 * @returns PersistentMessage Successful Response
	 * @throws ApiError
	 */
	public static threadsGetThreadMessages(data: ThreadsData['ThreadsGetThreadMessages']): CancelablePromise<Array<PersistentMessage>> {
		const {
threadId,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/threads/{thread_id}/messages',
			path: {
				thread_id: threadId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

}

export class BrainsService {

	/**
	 * Create a new brain
	 * Create a new brain
	 * @returns PersistentBrain Successful Response
	 * @throws ApiError
	 */
	public static brainsCreateBrain(data: BrainsData['BrainsCreateBrain']): CancelablePromise<PersistentBrain> {
		const {
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/brains',
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Update brain with given ID
	 * Update a brain
	 * @returns PersistentBrain Successful Response
	 * @throws ApiError
	 */
	public static brainsUpdateBrain(data: BrainsData['BrainsUpdateBrain']): CancelablePromise<PersistentBrain> {
		const {
brainId,
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'PUT',
			url: '/api/brains/{brain_id}',
			path: {
				brain_id: brainId
			},
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Delete a brain with given ID
	 * @returns void Successful Response
	 * @throws ApiError
	 */
	public static brainsDeleteBrain(data: BrainsData['BrainsDeleteBrain']): CancelablePromise<void> {
		const {
brainId,
} = data;
		return __request(OpenAPI, {
			method: 'DELETE',
			url: '/api/brains/{brain_id}',
			path: {
				brain_id: brainId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Get all brains for a user
	 * Get all brains for a user
	 * @returns PersistentBrain Successful Response
	 * @throws ApiError
	 */
	public static brainsGetBrainsForUserId(data: BrainsData['BrainsGetBrainsForUserId']): CancelablePromise<Array<PersistentBrain>> {
		const {
userId,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/brains/{user_id}',
			path: {
				user_id: userId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

}

export class MessagesService {

	/**
	 * Create new message
	 * @returns PersistentMessage Successful Response
	 * @throws ApiError
	 */
	public static messagesCreateMessage(data: MessagesData['MessagesCreateMessage']): CancelablePromise<PersistentMessage> {
		const {
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/messages',
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Update message with given ID
	 * @returns PersistentMessage Successful Response
	 * @throws ApiError
	 */
	public static messagesUpdateMessage(data: MessagesData['MessagesUpdateMessage']): CancelablePromise<PersistentMessage> {
		const {
messageId,
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'PUT',
			url: '/api/messages/{message_id}',
			path: {
				message_id: messageId
			},
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Delete message with given ID
	 * @returns void Successful Response
	 * @throws ApiError
	 */
	public static messagesDeleteMessage(data: MessagesData['MessagesDeleteMessage']): CancelablePromise<void> {
		const {
messageId,
} = data;
		return __request(OpenAPI, {
			method: 'DELETE',
			url: '/api/messages/{message_id}',
			path: {
				message_id: messageId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Get message processing status
	 * @returns PersistentMessage Successful Response
	 * @throws ApiError
	 */
	public static messagesGetMessage(data: MessagesData['MessagesGetMessage']): CancelablePromise<PersistentMessage> {
		const {
messageId,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/messages/{message_id}',
			path: {
				message_id: messageId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

}

export class AgentsService {

	/**
	 * Send a message to a Wayak Agent
	 * @returns PersistentMessage Successful Response
	 * @throws ApiError
	 */
	public static agentsGetWayakResponse(data: AgentsData['AgentsGetWayakResponse']): CancelablePromise<PersistentMessage> {
		const {
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/agents/wayak',
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Send a message to a specific agent
	 * @returns PersistentMessage Successful Response
	 * @throws ApiError
	 */
	public static agentsGetSpecificAgentResponse(data: AgentsData['AgentsGetSpecificAgentResponse']): CancelablePromise<PersistentMessage> {
		const {
agentId,
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/agents/agent/{agentId}',
			path: {
				agentId
			},
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Extract content from a file using OCR
	 * Extract content from a file (PDF or image) using OCR capabilities.
 * Returns a complete markdown document with embedded images.
 * 
 * Args:
 * file: The uploaded file (PDF or image)
 * schema: JSON schema defining fields to extract (as form data)
 * thread_id: Thread ID for the conversation
 * messages_interface: Interface for message operations
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static agentsExtractFileContent(data: AgentsData['AgentsExtractFileContent']): CancelablePromise<Record<string, unknown>> {
		const {
formData,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/agents/extraction',
			formData: formData,
			mediaType: 'multipart/form-data',
			errors: {
				422: `Validation Error`,
			},
		});
	}

}

export class OrganizationsService {

	/**
	 * Create Organization
	 * @returns Organization Successful Response
	 * @throws ApiError
	 */
	public static organizationsCreateOrganization(data: OrganizationsData['OrganizationsCreateOrganization']): CancelablePromise<Organization> {
		const {
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/organizations',
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Get User Organizations
	 * @returns Organization Successful Response
	 * @throws ApiError
	 */
	public static organizationsGetUserOrganizations(data: OrganizationsData['OrganizationsGetUserOrganizations']): CancelablePromise<Array<Organization>> {
		const {
userId,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/organizations',
			query: {
				user_id: userId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Get Organization
	 * @returns Organization Successful Response
	 * @throws ApiError
	 */
	public static organizationsGetOrganization(data: OrganizationsData['OrganizationsGetOrganization']): CancelablePromise<Organization> {
		const {
orgId,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/organizations/{org_id}',
			path: {
				org_id: orgId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Update Organization
	 * @returns Organization Successful Response
	 * @throws ApiError
	 */
	public static organizationsUpdateOrganization(data: OrganizationsData['OrganizationsUpdateOrganization']): CancelablePromise<Organization> {
		const {
orgId,
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'PUT',
			url: '/api/organizations/{org_id}',
			path: {
				org_id: orgId
			},
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Add Organization Member
	 * @returns OrgMembership Successful Response
	 * @throws ApiError
	 */
	public static organizationsAddOrganizationMember(data: OrganizationsData['OrganizationsAddOrganizationMember']): CancelablePromise<OrgMembership> {
		const {
orgId,
currentUserId,
userId,
role,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/organizations/{org_id}/members',
			path: {
				org_id: orgId
			},
			query: {
				current_user_id: currentUserId, user_id: userId, role
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Get Organization Members
	 * @returns OrgMembersResponse Successful Response
	 * @throws ApiError
	 */
	public static organizationsGetOrganizationMembers(data: OrganizationsData['OrganizationsGetOrganizationMembers']): CancelablePromise<OrgMembersResponse> {
		const {
orgId,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/organizations/{org_id}/members',
			path: {
				org_id: orgId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Remove Organization Member
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public static organizationsRemoveOrganizationMember(data: OrganizationsData['OrganizationsRemoveOrganizationMember']): CancelablePromise<unknown> {
		const {
orgId,
userId,
currentUserId,
} = data;
		return __request(OpenAPI, {
			method: 'DELETE',
			url: '/api/organizations/{org_id}/members/{user_id}',
			path: {
				org_id: orgId, user_id: userId
			},
			query: {
				current_user_id: currentUserId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Get Organization Projects
	 * @returns PersistentProject Successful Response
	 * @throws ApiError
	 */
	public static organizationsGetOrganizationProjects(data: OrganizationsData['OrganizationsGetOrganizationProjects']): CancelablePromise<Array<PersistentProject>> {
		const {
orgId,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/organizations/{org_id}/projects',
			path: {
				org_id: orgId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Get Organization Threads
	 * @returns PersistentThread Successful Response
	 * @throws ApiError
	 */
	public static organizationsGetOrganizationThreads(data: OrganizationsData['OrganizationsGetOrganizationThreads']): CancelablePromise<Array<PersistentThread>> {
		const {
orgId,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/organizations/{org_id}/threads',
			path: {
				org_id: orgId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Get Organization Brains
	 * @returns PersistentBrain Successful Response
	 * @throws ApiError
	 */
	public static organizationsGetOrganizationBrains(data: OrganizationsData['OrganizationsGetOrganizationBrains']): CancelablePromise<Array<PersistentBrain>> {
		const {
orgId,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/organizations/{org_id}/brains',
			path: {
				org_id: orgId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

}

export class OntologyService {

	/**
	 * Create a new dashboard
	 * Create a new dashboard with metrics layout
 * 
 * Args:
 * dashboard: The dashboard data to create
 * 
 * Returns:
 * The created dashboard
	 * @returns DashboardModel Successful Response
	 * @throws ApiError
	 */
	public static ontologyCreateDashboard(data: OntologyData['OntologyCreateDashboard']): CancelablePromise<DashboardModel> {
		const {
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/ontology/dashboards',
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Get all dashboards for an organization
	 * Get all dashboards for an organization
 * 
 * Args:
 * org_id: Organization ID to filter by
 * 
 * Returns:
 * List of dashboards
	 * @returns DashboardModel Successful Response
	 * @throws ApiError
	 */
	public static ontologyGetDashboards(data: OntologyData['OntologyGetDashboards']): CancelablePromise<Array<DashboardModel>> {
		const {
orgId,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/ontology/dashboards',
			query: {
				org_id: orgId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Get a dashboard by ID
	 * Get a dashboard by ID
 * 
 * Args:
 * dashboard_id: Dashboard ID to retrieve
 * 
 * Returns:
 * The dashboard
	 * @returns DashboardModel Successful Response
	 * @throws ApiError
	 */
	public static ontologyGetDashboard(data: OntologyData['OntologyGetDashboard']): CancelablePromise<DashboardModel> {
		const {
dashboardId,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/ontology/dashboards/{dashboard_id}',
			path: {
				dashboard_id: dashboardId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Update a dashboard
	 * Update a dashboard
 * 
 * Args:
 * dashboard_id: Dashboard ID to update
 * update_data: Data to update
 * 
 * Returns:
 * The updated dashboard
	 * @returns DashboardModel Successful Response
	 * @throws ApiError
	 */
	public static ontologyUpdateDashboard(data: OntologyData['OntologyUpdateDashboard']): CancelablePromise<DashboardModel> {
		const {
dashboardId,
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'PUT',
			url: '/api/ontology/dashboards/{dashboard_id}',
			path: {
				dashboard_id: dashboardId
			},
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Delete a dashboard
	 * Delete a dashboard
 * 
 * Args:
 * dashboard_id: Dashboard ID to delete
 * 
 * Returns:
 * The deleted dashboard
	 * @returns DashboardModel Successful Response
	 * @throws ApiError
	 */
	public static ontologyDeleteDashboard(data: OntologyData['OntologyDeleteDashboard']): CancelablePromise<DashboardModel> {
		const {
dashboardId,
} = data;
		return __request(OpenAPI, {
			method: 'DELETE',
			url: '/api/ontology/dashboards/{dashboard_id}',
			path: {
				dashboard_id: dashboardId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Execute Query
	 * @returns ExecuteQueryResponse Successful Response
	 * @throws ApiError
	 */
	public static ontologyExecuteQuery(data: OntologyData['OntologyExecuteQuery']): CancelablePromise<ExecuteQueryResponse> {
		const {
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'PUT',
			url: '/api/ontology/execute-query',
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Chat with a datasource agent for data analysis
	 * Start a chat session with a datasource agent that can analyze data from the
 * specified datasource using natural language. The endpoint dynamically selects
 * the appropriate tools based on the datasource type (Clickhouse, Postgres, etc.).
 * 
 * Args:
 * datasource_id: ID of the datasource to analyze
 * request: Chat request containing messages and other parameters
 * 
 * Returns:
 * PersistentMessage: An empty message that will be updated with the agent's response
	 * @returns PersistentMessage Successful Response
	 * @throws ApiError
	 */
	public static ontologyChatWithDatasourceAgent(data: OntologyData['OntologyChatWithDatasourceAgent']): CancelablePromise<PersistentMessage> {
		const {
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/ontology/agent/chat',
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Create a new Clickhouse datasource
	 * Create a new Clickhouse datasource
	 * @returns DataSourceModel Successful Response
	 * @throws ApiError
	 */
	public static ontologyCreateClickhouseDatasource(data: OntologyData['OntologyCreateClickhouseDatasource']): CancelablePromise<DataSourceModel> {
		const {
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/ontology/datasources/clickhouse',
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Get all datasources for an organization
	 * Get all datasources for an organization
	 * @returns DataSourceModel Successful Response
	 * @throws ApiError
	 */
	public static ontologyGetDatasources(data: OntologyData['OntologyGetDatasources']): CancelablePromise<Array<DataSourceModel>> {
		const {
orgId,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/ontology/datasources',
			query: {
				org_id: orgId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Get a datasource by ID
	 * Get a datasource by ID
	 * @returns DataSourceModel Successful Response
	 * @throws ApiError
	 */
	public static ontologyGetDatasource(data: OntologyData['OntologyGetDatasource']): CancelablePromise<DataSourceModel> {
		const {
datasourceId,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/ontology/datasources/{datasource_id}',
			path: {
				datasource_id: datasourceId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Update a Clickhouse datasource
	 * Update a Clickhouse datasource
	 * @returns DataSourceModel Successful Response
	 * @throws ApiError
	 */
	public static ontologyUpdateClickhouseDatasource(data: OntologyData['OntologyUpdateClickhouseDatasource']): CancelablePromise<DataSourceModel> {
		const {
datasourceId,
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'PUT',
			url: '/api/ontology/datasources/clickhouse/{datasource_id}',
			path: {
				datasource_id: datasourceId
			},
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Delete a Clickhouse datasource
	 * Delete a Clickhouse datasource
	 * @returns DataSourceModel Successful Response
	 * @throws ApiError
	 */
	public static ontologyDeleteClickhouseDatasource(data: OntologyData['OntologyDeleteClickhouseDatasource']): CancelablePromise<DataSourceModel> {
		const {
datasourceId,
} = data;
		return __request(OpenAPI, {
			method: 'DELETE',
			url: '/api/ontology/datasources/clickhouse/{datasource_id}',
			path: {
				datasource_id: datasourceId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Create a new metric
	 * Create a new metric
	 * @returns MetricModel Successful Response
	 * @throws ApiError
	 */
	public static ontologyCreateMetric(data: OntologyData['OntologyCreateMetric']): CancelablePromise<MetricModel> {
		const {
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'POST',
			url: '/api/ontology/metrics',
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Get all metrics for an organization
	 * Get all metrics for an organization
	 * @returns MetricModel Successful Response
	 * @throws ApiError
	 */
	public static ontologyGetMetrics(data: OntologyData['OntologyGetMetrics']): CancelablePromise<Array<MetricModel>> {
		const {
orgId,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/ontology/metrics',
			query: {
				org_id: orgId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Get a metric by ID
	 * Get a metric by ID
	 * @returns MetricModel Successful Response
	 * @throws ApiError
	 */
	public static ontologyGetMetric(data: OntologyData['OntologyGetMetric']): CancelablePromise<MetricModel> {
		const {
metricId,
} = data;
		return __request(OpenAPI, {
			method: 'GET',
			url: '/api/ontology/metrics/{metric_id}',
			path: {
				metric_id: metricId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Update a metric
	 * Update a metric
	 * @returns MetricModel Successful Response
	 * @throws ApiError
	 */
	public static ontologyUpdateMetric(data: OntologyData['OntologyUpdateMetric']): CancelablePromise<MetricModel> {
		const {
metricId,
requestBody,
} = data;
		return __request(OpenAPI, {
			method: 'PUT',
			url: '/api/ontology/metrics/{metric_id}',
			path: {
				metric_id: metricId
			},
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`,
			},
		});
	}

	/**
	 * Delete a metric
	 * Delete a metric
	 * @returns MetricModel Successful Response
	 * @throws ApiError
	 */
	public static ontologyDeleteMetric(data: OntologyData['OntologyDeleteMetric']): CancelablePromise<MetricModel> {
		const {
metricId,
} = data;
		return __request(OpenAPI, {
			method: 'DELETE',
			url: '/api/ontology/metrics/{metric_id}',
			path: {
				metric_id: metricId
			},
			errors: {
				422: `Validation Error`,
			},
		});
	}

}